// Fleet-maintained — the devbloom-automation bot refreshes this file.
// To update: tally merged feature/* PRs across dev-bloom org + total merged PRs,
// then bump `lastUpdated`, `summary`, and prepend a new entry to `weekly`.

interface WeeklySnapshot {
  weekOf: string; // ISO date of Monday starting the week
  featuresShipped: number;
  prsMerged: number;
  reposTouched: number;
}

export interface BuildMetrics {
  lastUpdated: string; // ISO date
  summary: {
    featuresShipped: number; // cumulative merged feature/* PRs across org
    reposInProduction: number;
    prsMerged: number; // cumulative total merged PRs across org
  };
  weekly: WeeklySnapshot[]; // newest first, ~6 weeks
}

export const BUILD_METRICS: BuildMetrics = {
  lastUpdated: "2026-06-21",
  summary: {
    featuresShipped: 141,
    reposInProduction: 10,
    prsMerged: 609,
  },
  weekly: [
    { weekOf: "2026-06-15", featuresShipped: 121, prsMerged: 303, reposTouched: 10 },
    { weekOf: "2026-06-08", featuresShipped: 17, prsMerged: 190, reposTouched: 10 },
    { weekOf: "2026-06-01", featuresShipped: 1, prsMerged: 30, reposTouched: 5 },
  ],
};
